import { get } from "lodash";
import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";

import { colors } from "../pages/css components/Style";

const TextFieldWithCSS = styled(MuiTextField)`
  .MuiTextField-root {
    padding: 8px;
    color :${colors.text}
    border-color: ${colors.sprintexBlue} !important;
  }

  & label.Mui-focused {
    color: ${colors.sprintexBlue};
  }

  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${colors.sprintexBlue};
    }
  }

  .MuiInputLabel-root {
    color :${colors.text}
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 5px;
    border-color: ${colors.sprintexBlue};
  }

  .MuiOutlinedInput-root {
    font-size: 16px;
    color :${colors.text}
    border-color: ${colors.sprintexBlue};
    border-radius: 5px;
  }

  .Mui-disabled {
    color: rgba(0, 0, 0, 0.66);
    font-size: 16px;
    border-radius: 5px;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.66);
  }

  .MuiInputLabel-outlined {
    font-size: 16px;
    color :${colors.text}
  }

  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: #f5f5f5;
    border: 1px solid #c4cacb;
  }

  .MuiInputBase-input {
    color :${colors.text}
    border-color: ${colors.sprintexBlue};
  }

  #mui-7-helper-text {
    color: red;
  }
  .MuiInputLabel-asterisk {
    color: ${(props) => (Boolean(props.required && !props.value) ? "red" : "")};
  }


`;

export default function TextField({ formikProps, ...props }) {
  if (!!formikProps) {
    function handleTouch() {
      if (Object.keys(formikProps?.touched).length > 0) {
        for (let field in formikProps.touched) {
          if (field !== props.name) {
            formikProps.setTouched({
              ...formikProps.touched,
              [props.name]: true,
            });
          } else {
            formikProps.setTouched({ [props.name]: true });
          }
        }
      } else {
        formikProps.setTouched({ [props.name]: true });
      }
    }

    return (
      <TextFieldWithCSS
        size="small"
        onClick={handleTouch}
        onChange={formikProps.handleChange}
        error={
          get(formikProps.touched, props.name) && props.select
            ? Boolean(
                !get(formikProps.values, props.name) &&
                  get(formikProps.errors, props.name)
              )
            : !!get(formikProps.touched, props.name) &&
              get(formikProps.errors, props.name)
        }
        helperText={
          get(formikProps.touched, props.name) && props.select
            ? !get(formikProps.values, props.name) &&
              get(formikProps.errors, props.name)
            : !!get(formikProps.touched, props.name) &&
              get(formikProps.errors, props.name)
        }
        onBlur={formikProps.handleBlur}
        value={get(formikProps.values, props.name, "")}
        fullWidth
        variant="outlined"
        {...props}
      />
    );
  }

  return <TextFieldWithCSS variant="outlined" fullWidth {...props} />;
}
